import React from "react";
import { Icons } from "fds";
import { getFileTypeIconAsUrl } from "@fluentui/react-file-type-icons";
const utilsDocs = {
  renderDocIcon: (
    name?: string,
    size?: number | string,
    officeType?: "collabora" | "ms365" | "normal",
    style?: React.CSSProperties
  ): React.ReactNode => {
    const fileType = name ? name.substring(name.lastIndexOf(".") + 1) : "";
    if (!window.eco.isCspp) {
      if (!!officeType && officeType !== "normal") {
        switch (fileType.toLowerCase()) {
          case "docx":
          case "doc":
          case "docm":
            return (
              <Icons
                variant="document"
                style={style}
                label={officeType === "ms365" ? "officeWord" : "collabWord"}
                size={size}
              />
            );
          case "ppt":
          case "pptx":
            return (
              <Icons
                style={style}
                variant="document"
                label={officeType === "ms365" ? "officePpt" : "collabPpt"}
                size={size}
              />
            );
          case "xls":
          case "xlsx":
            return (
              <Icons
                variant="document"
                style={style}
                label={officeType === "ms365" ? "officeExcel" : "collabExcel"}
                size={size}
              />
            );
          default:
            return <></>;
        }
      }
      switch (fileType.toLowerCase()) {
        case "docx":
        case "doc":
        case "docm":
          return (
            <Icons variant="document" label="word" size={size} style={style} />
          );
        case "ppt":
        case "pptx":
          return (
            <Icons variant="document" label="ppt" size={size} style={style} />
          );
        case "pdf":
          return (
            <Icons variant="document" label="pdf" size={size} style={style} />
          );
        case "xls":
        case "xlsx":
          return (
            <Icons variant="document" label="excel" size={size} style={style} />
          );
        case "hwp":
        case "hwpx":
          return (
            <Icons variant="document" label="hwp" size={size} style={style} />
          );
        case "png":
        case "jpg":
        case "jpeg":
          return (
            <Icons variant="document" label="image" size={size} style={style} />
          );
        case "zip":
          return (
            <Icons variant="document" label="zip" size={size} style={style} />
          );
        case "txt":
          return (
            <Icons variant="document" label="txt" size={size} style={style} />
          );
        case "dwg":
          return (
            <Icons variant="document" label="cad" size={size} style={style} />
          );
        default:
          return (
            <Icons variant="document" label="etc" size={size} style={style} />
          );
      }
    } else {
      const validSizes = [16, 20, 24, 32, 48, 96] as const;
      const numSize =
        typeof size === "string" ? parseInt(size, 10) : size ?? 32;
      const fluentSize = validSizes.reduce((prev, curr) =>
        Math.abs(curr - numSize) < Math.abs(prev - numSize) ? curr : prev
      );
      const iconUrl = getFileTypeIconAsUrl({
        extension: fileType || "txt",
        size: fluentSize,
      });
      return (
        <img
          src={iconUrl}
          width={numSize}
          height={numSize}
          style={style}
          alt={fileType}
        />
      );
    }
  },
  fileSizeFormat: (size?: number, numFixed?: number): string => {
    let result = "";
    if (!size) return "0 bytes";
    const s = ["bytes", "KB", "MB", "GB", "TB", "PB"];
    const e = Math.floor(Math.log(size) / Math.log(1024));

    if (e === -Infinity) {
      result = "0 " + s[0];
    } else {
      result =
        (size / Math.pow(1024, Math.floor(e))).toFixed(numFixed ?? 2) +
        "" +
        s[e];
    }
    return result;
  },
  fileFormattoStr: (fileName?: string): string => {
    const fileType = fileName
      ? fileName.substring(fileName.lastIndexOf(".") + 1)
      : "";

    if (window.eco.isCspp) {
      switch (fileType.toLowerCase()) {
        case "docx":
        case "doc":
        case "docm":
          return "Microsoft Word";
        case "pptx":
        case "ppt":
          return "Microsoft PowerPoint";
        case "pdf":
          return "PDF";
        case "xlsx":
        case "xls":
          return "Microsoft Excel";
        case "hwp":
        case "hwpx":
          return "Hancom Hwp";
        case "png":
          return "PNG image";
        case "jpg":
          return "JPG image";
        case "jpeg":
          return "JPEG image";
        case "zip":
          return "ZIP archive";
        case "txt":
          return "text file";
        default:
          return "other file";
      }
    } else {
      switch (fileType.toLowerCase()) {
        case "docx":
        case "doc":
        case "docm":
          return "MS Word";
        case "pptx":
        case "ppt":
          return "MS PowerPoint";
        case "pdf":
          return "PDF";
        case "xlsx":
        case "xls":
          return "MS Excel";
        case "hwp":
        case "hwpx":
          return "Hancom Hwp";
        case "png":
          return "PNG image";
        case "jpg":
          return "JPG image";
        case "jpeg":
          return "JPEG image";
        case "zip":
          return "ZIP archive";
        case "txt":
          return "text file";
        default:
          return "other file";
      }
    }
  },
  renderDocProgressIcon: (status: string, isSupportExt: boolean) => {
    switch (status) {
      case "SUCCESS":
        return isSupportExt ? (
          <Icons variant="fill" label="docSuccess" />
        ) : (
          <Icons variant="fill" label="docWarning" />
        );
      case "FAIL":
        return <Icons variant="fill" label="docFail" />;
      case "ING":
        return <Icons variant="fill" label="docLoading" />;
      default:
        return <Icons variant="fill" label="docLoading" percent={0} />;
    }
  },
};

export default utilsDocs;
